import { mapActions } from 'vuex'
import { sorts } from './partials/wallet/fields'
import { sorts as invoiceSorts } from './partials/invoice/fields'

export default {
    template: '<router-view />',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setParamsTransactions({
                sorter: {
                    direction: 'DESC'
                }
            })
            vm.fetchTransactions()
            if (vm.$policy('financial').write_any_or_group) {
                vm.setParamsWallet({
                    sorter: sorts[0].value,
                })
                vm.fetchReports()
                vm.fetchWallets()
            }

            if (vm.$policy('financial').write) {
                vm.fetchInvoices()
                vm.setParamsInvoice({
                    sorter: invoiceSorts[0].value,
                })
            }
        })
    },

    methods: {
        ...mapActions({
            fetchTransactions: 'transaction/fetch',
            fetchReports: 'transaction/fetchReports',
            setParamsTransactions: 'transaction/setParams',
            setParamsWallet: 'wallet/setParams',
            fetchWallets: 'wallet/fetch',
            fetchInvoices: 'invoice/fetch',
            setParamsInvoice: 'invoice/setParams',
        }),
    }
}